@if (!isLoading) {
    <div mat-dialog-title class="d-flex align-items-center m-0">
        <h3 class="w-100">{{ 'Report.Report' | translate }}: {{ reportModel.description }}</h3>
        @if (isEditing) {
            <mat-icon color="warn" [matTooltip]="'General.Delete' | translate" (click)="deleteReportSchedule()">delete</mat-icon>
        }
    </div>
    <div mat-dialog-content>
        <form [formGroup]="formGroup" class="d-flex flex-column">
            <mat-form-field>
                <mat-label>{{ 'ReportSchedule.Format' | translate }}</mat-label>
                <mat-select [formControl]="formGroup.controls['reportFormat'] | formControl">
                    @for (format of reportFormats; track format.id) {
                        <mat-option [value]="format.id">{{ format.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <sl-cron-input formControlName="nextExecutionCronSchedule" labelKey="ReportSchedule.Schedule" />
            <mat-form-field class="mt-2">
                <mat-label>{{ 'ReportSchedule.DeleteReportAfter' | translate }}</mat-label>
                <input matInput [formControl]="formGroup.controls['reportValidForDays'] | formControl" type="number" min="1" max="365" />
                <span matSuffix class="mx-2">{{ 'ReportSchedule.Days' | translate }}</span>
                <mat-error>
                    <sl-form-field-error-control [control]="formGroup.controls['reportValidForDays']" />
                </mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="shouldReceiveEmailNotification">
                {{ 'ReportSchedule.SendEmailNotification' | translate }}
            </mat-checkbox>
            @if (!!reportParameterFields && reportParameterFields.length > 0) {
                <div formGroupName="parameters">
                    <h2 class="form-subtitle">{{ 'Alerts.Parameters' | translate }}</h2>
                    @for (parameterField of reportParameterFields; track parameterField.name) {
                        <sl-report-schedule-dialog-parameter-field
                            [parameterField]="parameterField"
                            [formControlName]="parameterField.name"
                            [class]="parameterField.name"
                            [required]="!parameterField.isNullable" />
                    }
                </div>
            }
        </form>
    </div>
    <div mat-dialog-actions class="float-right">
        <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
        <button mat-button (click)="save()" color="primary">{{ 'General.Save' | translate }}</button>
    </div>
} @else {
    <div class="d-flex justify-content-center my-4">
        <mat-spinner [diameter]="50" />
    </div>
}
